import React, { useState } from 'react';

import {
	useQuery as useLibQuery,
	UseQueryOptions,
} from '@tanstack/react-query';

import { useOwnAppProvider } from '../AppContainer/useOwnApp';

import { useQueryKey } from '../data';
import { useAppState } from '../store/appStore';

const isQueryEnabled = ({ appName }: { appName?: string | null }) =>
	appName ? true : false;

export function useQuery<TData = any, TError = any, TSelect = TData>(
	options: UseQueryOptions<TData, TError, TSelect> & {
		skipOwnApp?: boolean;
	}
) {
	const { currentAppName: appName, isCustomAppActive: isAppOwn } =
		useAppState();
	const queryKey = useQueryKey({ queryKey: options.queryKey });

	const [queryOptions, setQueryOptions] = useState({
		...options,
		enabled: false,
	});

	const [isRouteOwnApp] = useOwnAppProvider();

	const manageOptions = () => {
		// TODO: refactor other conditions to be inside isQueryEnabled
		options.enabled =
			(options.enabled ?? isQueryEnabled({ appName })) &&
			((isRouteOwnApp && isAppOwn) ||
				!isRouteOwnApp ||
				options?.skipOwnApp === true);

		setQueryOptions({ ...(options as any) });
	};

	React.useEffect(() => {
		manageOptions();
	}, [isAppOwn, isRouteOwnApp, appName]);

	const q = useLibQuery({
		...queryOptions,
		queryKey,
		enabled: options.enabled ?? isQueryEnabled({ appName }),
	});

	return {
		...q,
		data: q.data as TData,
		isLoading: q.isLoading,
	};
}
